export default __webpack_public_path__ + "23cbdea338aa09698e319af865a82552.svg";